import { AbstractComponent } from "appworks/components/abstract-component";
import { Services } from "appworks/services/services";
import { gameLayers } from "game-layers";

export class TGRJackpotValuesComponent extends AbstractComponent {

    public init(): void {
        super.init();
        this.initListener();
        this.updateJackpotValues();
    }

    protected initListener(): void {
        Services.bet.onBetChange.add(() => this.updateJackpotValues());
    }

    protected updateJackpotValues(): void {
        const stake: number = Services.bet.getTotalStake();
        gameLayers.JackpotValues.getText("mini").text = Services.currency.format(50 * stake, false);
        gameLayers.JackpotValues.getText("minor").text = Services.currency.format(100 * stake, false);
        gameLayers.JackpotValues.getText("major").text = Services.currency.format(200 * stake, false);
        gameLayers.JackpotValues.getText("grand").text = Services.currency.format(1000 * stake, false);
    }
}
